// extracted by mini-css-extract-plugin
export default {"container":"_Z2OQ","form":"A62oa"};